import React from 'react';
import { Link } from 'react-router-dom';

export default function SimilarProductsCarousel({ title, items }) {
  const viewportRef = React.useRef(null);

  const [canScrollLeft, setCanScrollLeft] = React.useState(false);
  const [canScrollRight, setCanScrollRight] = React.useState(false);

  const updateButtons = React.useCallback(() => {
    const el = viewportRef.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    setCanScrollLeft(el.scrollLeft > 1);
    setCanScrollRight(el.scrollLeft < max - 1);
  }, []);

  React.useEffect(() => {
    updateButtons();
  }, [items, updateButtons]);

  React.useEffect(() => {
    const el = viewportRef.current;
    if (!el) return undefined;

    const onScroll = () => updateButtons();
    el.addEventListener('scroll', onScroll, { passive: true });

    const ro = new ResizeObserver(() => updateButtons());
    ro.observe(el);

    return () => {
      el.removeEventListener('scroll', onScroll);
      ro.disconnect();
    };
  }, [updateButtons]);

  const scrollByOneCard = React.useCallback((dir) => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const firstItem = viewport.querySelector('[data-carousel-item="true"]');
    const step = firstItem ? firstItem.getBoundingClientRect().width + 18 : Math.round(viewport.clientWidth / 4);

    viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
  }, []);

  if (!items?.length) return null;

  return (
    <section className="yk-card yk-similarCard" aria-label={title}>
      <div className="yk-similarHeader">
        <h2 className="yk-h2 yk-similarTitle">{title}</h2>
        <div className="yk-similarArrows">
          <button
            type="button"
            className="yk-carouselArrow"
            onClick={() => scrollByOneCard(-1)}
            disabled={!canScrollLeft}
            aria-label="Previous"
          >
            ‹
          </button>
          <button
            type="button"
            className="yk-carouselArrow"
            onClick={() => scrollByOneCard(1)}
            disabled={!canScrollRight}
            aria-label="Next"
          >
            ›
          </button>
        </div>
      </div>

      <div className="yk-carouselViewport" ref={viewportRef}>
        <div className="yk-carouselTrack">
          {items.map((it) => (
            <Link key={it.to} to={it.to} className="yk-carouselItem" data-carousel-item="true">
              <div className="yk-carouselImgWrap">
                <img
                  className={it.isPhoto ? 'yk-carouselImg is-photo' : 'yk-carouselImg'}
                  src={it.imgSrc}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="yk-carouselBody">
                <div className="yk-carouselTitle">{it.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
